import type { DrillingMultiAnalysisStateParams } from '@go-widgets/well-logs-widget';

import type { TDrillingMultiAnalysisSerializedInternalState } from './DrillingMultiAnalysisWidget.entity';

export function parseDrillingMultiAnalysisWidgetInternalState(
  state: object,
): TDrillingMultiAnalysisSerializedInternalState {
  let stateParams: Partial<DrillingMultiAnalysisStateParams> = {};
  let wellId: number | null = null;

  if ('wellId' in state && typeof state.wellId === 'number') {
    wellId = state.wellId;
  }

  if ('stateParams' in state && typeof state.stateParams === 'object' && !!state.stateParams) {
    stateParams = state.stateParams as Partial<DrillingMultiAnalysisStateParams>;
  }

  return { stateParams, wellId };
}
